import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useViewer } from '@/features/session';
import { DISCONNECT_CODEX } from '@/graphql/mutations/connections';

type UseDisconnectCodexResult = { disconnectCodex: () => Promise<void>; isDisconnecting: boolean };

export function useDisconnectCodex(): UseDisconnectCodexResult {
  const { refreshViewer } = useViewer();
  const [mutate, { loading }] = useMutation(DISCONNECT_CODEX);

  const disconnectCodex = useCallback(async () => {
    await mutate();
    await refreshViewer();
  }, [mutate, refreshViewer]);

  return { disconnectCodex, isDisconnecting: loading };
}
